/* Back-to-top button.

   The button is rendered with the `hidden` attribute and only revealed here,
   so with scripts off nothing shows rather than a button that does nothing.

   Note: the element reference is deliberately NOT called `top` — that name
   collides with the read-only `window.top`, the assignment silently fails,
   and the button never works. That cost an hour once. */
(function () {
  'use strict';

  function init() {
    var btn = document.getElementById('fx-totop');
    if (!btn || btn._fxReady) return;
    btn._fxReady = true;

    var after = parseInt(btn.getAttribute('data-after'), 10);
    if (isNaN(after)) after = 400;
    btn.hidden = false;

    var ticking = false;
    function paint() {
      btn.classList.toggle('is-on', window.scrollY > after);
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
